export default __webpack_public_path__ + "static/media/793.2a38eaa3.png";